// Reviewed questionnaire copy. Edit all five languages together; never reuse an ID for a new meaning.
import type { LocalizedQuestionDefinition } from './types';

export const questionnaireCatalog: LocalizedQuestionDefinition[] = [
  {
    "id": "v2_relationshipGoals",
    "contextField": "relationshipGoals",
    "tier": 1,
    "askAt": "onboarding",
    "text": {
      "en": "What would you like us to help you with?",
      "fr": "Sur quoi aimeriez-vous un coup de main ?",
      "es": "¿En qué te gustaría que te ayudáramos?",
      "de": "Wobei wünschst du dir Unterstützung?",
      "it": "Su cosa vorresti una mano?"
    },
    "options": [
      {
        "value": "talking",
        "label": {
          "en": "Talking things through",
          "fr": "Mieux se parler",
          "es": "Hablar las cosas",
          "de": "Miteinander reden",
          "it": "Parlare delle cose"
        }
      },
      {
        "value": "time",
        "label": {
          "en": "Making time for each other",
          "fr": "Trouver du temps à deux",
          "es": "Encontrar tiempo para estar juntos",
          "de": "Zeit füreinander finden",
          "it": "Trovare tempo per noi"
        }
      },
      {
        "value": "closeness",
        "label": {
          "en": "Feeling closer",
          "fr": "Se sentir plus proches",
          "es": "Sentirnos más cerca",
          "de": "Uns näher fühlen",
          "it": "Sentirci più vicini"
        }
      },
      {
        "value": "disagreements",
        "label": {
          "en": "Handling disagreements",
          "fr": "Mieux vivre les désaccords",
          "es": "Llevar mejor los desacuerdos",
          "de": "Mit Meinungsverschiedenheiten umgehen",
          "it": "Affrontare i disaccordi"
        }
      },
      {
        "value": "fun",
        "label": {
          "en": "Having fun together",
          "fr": "S'amuser ensemble",
          "es": "Divertirnos juntos",
          "de": "Zusammen Spaß haben",
          "it": "Divertirci insieme"
        }
      },
      {
        "value": "everyday",
        "label": {
          "en": "Managing everyday responsibilities",
          "fr": "Gérer les responsabilités du quotidien",
          "es": "Organizar las responsabilidades del día a día",
          "de": "Den Alltag gemeinsam organisieren",
          "it": "Gestire gli impegni quotidiani"
        }
      },
      {
        "value": "keep_going",
        "label": {
          "en": "Keeping a good thing going",
          "fr": "Entretenir ce qui va bien",
          "es": "Cuidar lo que ya va bien",
          "de": "Bewahren, was gut läuft",
          "it": "Coltivare ciò che funziona"
        }
      },
      {
        "value": "exploring",
        "label": {
          "en": "I'm just exploring",
          "fr": "Je découvre l'appli",
          "es": "Solo estoy explorando",
          "de": "Ich schaue mich erst mal um",
          "it": "Sto solo esplorando"
        }
      }
    ],
    "multiSelect": 3
  },
  {
    "id": "v2_relationshipKind",
    "contextField": "relationshipKind",
    "tier": 1,
    "askAt": "onboarding",
    "text": {
      "en": "How would you describe your relationship?",
      "fr": "Comment décririez-vous votre relation ?",
      "es": "¿Cómo describirías tu relación?",
      "de": "Wie würdest du eure Beziehung beschreiben?",
      "it": "Come descriveresti la vostra relazione?"
    },
    "options": [
      {
        "value": "dating",
        "label": {
          "en": "We're getting to know each other",
          "fr": "Nous apprenons à nous connaître",
          "es": "Estamos conociéndonos",
          "de": "Wir lernen uns gerade kennen",
          "it": "Ci stiamo conoscendo"
        }
      },
      {
        "value": "together",
        "label": {
          "en": "We're a couple",
          "fr": "Nous sommes en couple",
          "es": "Somos pareja",
          "de": "Wir sind ein Paar",
          "it": "Stiamo insieme"
        }
      },
      {
        "value": "engaged",
        "label": {
          "en": "We're engaged",
          "fr": "Nous sommes fiancés",
          "es": "Tenemos planes de casarnos",
          "de": "Wir sind verlobt",
          "it": "Abbiamo deciso di sposarci"
        }
      },
      {
        "value": "married",
        "label": {
          "en": "We're married",
          "fr": "Nous sommes mariés",
          "es": "Estamos casados",
          "de": "Wir sind verheiratet",
          "it": "Siamo sposati"
        }
      },
      {
        "value": "other",
        "label": {
          "en": "We describe it differently",
          "fr": "Nous la décrivons autrement",
          "es": "La describimos de otra manera",
          "de": "Wir beschreiben das anders",
          "it": "La descriviamo in un altro modo"
        }
      }
    ]
  },
  {
    "id": "v2_livingArrangement",
    "contextField": "livingArrangement",
    "tier": 1,
    "askAt": "onboarding",
    "text": {
      "en": "Do you and your partner live together?",
      "fr": "Vivez-vous avec votre partenaire ?",
      "es": "¿Vives con tu pareja?",
      "de": "Wohnt ihr zusammen?",
      "it": "Vivete insieme?"
    },
    "options": [
      {
        "value": "together",
        "label": {
          "en": "We live together",
          "fr": "Nous vivons ensemble",
          "es": "Vivimos juntos",
          "de": "Wir wohnen zusammen",
          "it": "Viviamo insieme"
        }
      },
      {
        "value": "nearby",
        "label": {
          "en": "We live separately, near each other",
          "fr": "Nous vivons séparément, près l'un de l'autre",
          "es": "Vivimos por separado, pero cerca",
          "de": "Wir wohnen getrennt, aber nah beieinander",
          "it": "Viviamo separati, ma vicini"
        }
      },
      {
        "value": "far_apart",
        "label": {
          "en": "We live far apart",
          "fr": "Nous vivons loin l'un de l'autre",
          "es": "Vivimos lejos",
          "de": "Wir wohnen weit voneinander entfernt",
          "it": "Viviamo lontani"
        }
      },
      {
        "value": "changing",
        "label": {
          "en": "Our living situation is changing",
          "fr": "Notre situation est en train de changer",
          "es": "Nuestra situación está cambiando",
          "de": "Unsere Wohnsituation verändert sich gerade",
          "it": "La nostra situazione sta cambiando"
        }
      },
      {
        "value": "other",
        "label": {
          "en": "It's a different arrangement",
          "fr": "Nous avons une autre organisation",
          "es": "Tenemos otra forma de organizarnos",
          "de": "Bei uns ist es anders",
          "it": "Abbiamo un'altra organizzazione"
        }
      }
    ]
  },
  {
    "id": "v2_coupleStrength",
    "contextField": "coupleStrength",
    "tier": 1,
    "askAt": "onboarding",
    "text": {
      "en": "What's something you do well as a couple?",
      "fr": "Qu'est-ce que vous faites bien à deux ?",
      "es": "¿Qué se les da bien como pareja?",
      "de": "Was gelingt euch als Paar gut?",
      "it": "Cosa vi riesce bene come coppia?"
    },
    "options": [
      {
        "value": "talking",
        "label": {
          "en": "We can talk to each other",
          "fr": "Nous arrivons à nous parler",
          "es": "Podemos hablar las cosas",
          "de": "Wir können miteinander reden",
          "it": "Riusciamo a parlarci"
        }
      },
      {
        "value": "trust",
        "label": {
          "en": "We trust each other",
          "fr": "Nous nous faisons confiance",
          "es": "Confiamos el uno en el otro",
          "de": "Wir vertrauen einander",
          "it": "Ci fidiamo a vicenda"
        }
      },
      {
        "value": "fun",
        "label": {
          "en": "We have fun together",
          "fr": "Nous nous amusons ensemble",
          "es": "Nos divertimos juntos",
          "de": "Wir haben zusammen Spaß",
          "it": "Ci divertiamo insieme"
        }
      },
      {
        "value": "support",
        "label": {
          "en": "We support each other",
          "fr": "Nous nous soutenons",
          "es": "Nos apoyamos",
          "de": "Wir unterstützen einander",
          "it": "Ci sosteniamo a vicenda"
        }
      },
      {
        "value": "team",
        "label": {
          "en": "We get through hard times together",
          "fr": "Nous traversons les moments difficiles ensemble",
          "es": "Superamos juntos los momentos difíciles",
          "de": "Wir stehen schwierige Zeiten zusammen durch",
          "it": "Superiamo insieme i momenti difficili"
        }
      },
      {
        "value": "friendship",
        "label": {
          "en": "We're good friends, too",
          "fr": "Nous sommes aussi de bons amis",
          "es": "También somos buenos amigos",
          "de": "Wir sind auch gut befreundet",
          "it": "Siamo anche buoni amici"
        }
      },
      {
        "value": "unsure",
        "label": {
          "en": "I'm not sure yet",
          "fr": "Je ne sais pas encore",
          "es": "Todavía no lo sé",
          "de": "Das weiß ich noch nicht",
          "it": "Non lo so ancora"
        }
      }
    ]
  },
  {
    "id": "v2_parentingSituation",
    "contextField": "parentingSituation",
    "tier": 1,
    "askAt": "onboarding",
    "text": {
      "en": "Do you have children?",
      "fr": "Avez-vous des enfants ?",
      "es": "¿Tienes hijos?",
      "de": "Hast du Kinder?",
      "it": "Hai figli?"
    },
    "options": [
      {
        "value": "none",
        "label": {
          "en": "No",
          "fr": "Non",
          "es": "No",
          "de": "Nein",
          "it": "No"
        }
      },
      {
        "value": "young",
        "label": {
          "en": "Yes, all under 6",
          "fr": "Oui, tous ont moins de 6 ans",
          "es": "Sí, todos menores de 6 años",
          "de": "Ja, alle unter 6 Jahren",
          "it": "Sì, tutti sotto i 6 anni"
        }
      },
      {
        "value": "school",
        "label": {
          "en": "Yes, all aged 6–12",
          "fr": "Oui, tous ont entre 6 et 12 ans",
          "es": "Sí, todos tienen entre 6 y 12 años",
          "de": "Ja, alle zwischen 6 und 12 Jahren",
          "it": "Sì, tutti tra i 6 e i 12 anni"
        }
      },
      {
        "value": "teen",
        "label": {
          "en": "Yes, all aged 13–17",
          "fr": "Oui, tous ont entre 13 et 17 ans",
          "es": "Sí, todos tienen entre 13 y 17 años",
          "de": "Ja, alle zwischen 13 und 17 Jahren",
          "it": "Sì, tutti tra i 13 e i 17 anni"
        }
      },
      {
        "value": "mixed",
        "label": {
          "en": "Yes, in different age groups",
          "fr": "Oui, dans différents groupes d'âge",
          "es": "Sí, de distintos grupos de edad",
          "de": "Ja, in verschiedenen Altersgruppen",
          "it": "Sì, in fasce d'età diverse"
        }
      },
      {
        "value": "adult",
        "label": {
          "en": "My children are all adults",
          "fr": "Mes enfants sont tous adultes",
          "es": "Todos mis hijos son adultos",
          "de": "Meine Kinder sind alle erwachsen",
          "it": "I miei figli sono tutti adulti"
        }
      }
    ]
  },
  {
    "id": "v2_affectionReceived",
    "contextField": "affectionReceived",
    "tier": 2,
    "askAt": "wave_1",
    "text": {
      "en": "What makes you feel loved?",
      "fr": "Qu'est-ce qui vous fait vous sentir aimé ?",
      "es": "¿Qué te hace sentir que te quieren?",
      "de": "Was gibt dir das Gefühl, geliebt zu werden?",
      "it": "Cosa ti fa sentire l'affetto dell'altra persona?"
    },
    "options": [
      {
        "value": "words",
        "label": {
          "en": "Kind words",
          "fr": "Des mots gentils",
          "es": "Palabras cariñosas",
          "de": "Liebe Worte",
          "it": "Parole affettuose"
        }
      },
      {
        "value": "help",
        "label": {
          "en": "A hand with everyday things",
          "fr": "Un coup de main au quotidien",
          "es": "Una mano con las cosas del día a día",
          "de": "Hilfe im Alltag",
          "it": "Una mano nelle cose di tutti i giorni"
        }
      },
      {
        "value": "gift",
        "label": {
          "en": "A gift chosen with me in mind",
          "fr": "Un cadeau choisi en pensant à moi",
          "es": "Un regalo elegido pensando en mí",
          "de": "Ein Geschenk, das zu mir passt",
          "it": "Un regalo scelto pensando a me"
        }
      },
      {
        "value": "touch",
        "label": {
          "en": "Hugs, kisses, or holding hands",
          "fr": "Des câlins, des bisous ou se tenir la main",
          "es": "Abrazos, besos o tomarnos de la mano",
          "de": "Umarmungen, Küsse oder Händchenhalten",
          "it": "Abbracci, baci o tenerci per mano"
        }
      },
      {
        "value": "attention",
        "label": {
          "en": "Time together without distractions",
          "fr": "Du temps à deux sans distractions",
          "es": "Tiempo juntos sin distracciones",
          "de": "Zeit zu zweit ohne Ablenkung",
          "it": "Tempo insieme senza distrazioni"
        }
      }
    ],
    "multiSelect": 2
  },
  {
    "id": "v2_affectionGiven",
    "contextField": "affectionGiven",
    "tier": 2,
    "askAt": "wave_1",
    "text": {
      "en": "How do you usually show your partner you care?",
      "fr": "Comment montrez-vous à votre partenaire que vous tenez à cette personne ?",
      "es": "¿Cómo sueles mostrarle a tu pareja que te importa?",
      "de": "Wie zeigst du dem Menschen an deiner Seite, dass er dir wichtig ist?",
      "it": "Come dimostri di solito il tuo affetto nella coppia?"
    },
    "options": [
      {
        "value": "words",
        "label": {
          "en": "I say something kind",
          "fr": "Je dis quelque chose de gentil",
          "es": "Digo algo cariñoso",
          "de": "Ich sage etwas Liebes",
          "it": "Dico qualcosa di affettuoso"
        }
      },
      {
        "value": "help",
        "label": {
          "en": "I lend a hand",
          "fr": "Je donne un coup de main",
          "es": "Echo una mano",
          "de": "Ich helfe im Alltag",
          "it": "Do una mano"
        }
      },
      {
        "value": "gift",
        "label": {
          "en": "I choose a little gift",
          "fr": "Je choisis un petit cadeau",
          "es": "Elijo un pequeño regalo",
          "de": "Ich suche ein kleines Geschenk aus",
          "it": "Scelgo un piccolo regalo"
        }
      },
      {
        "value": "touch",
        "label": {
          "en": "I show physical affection",
          "fr": "Je fais un geste affectueux",
          "es": "Doy abrazos, besos o caricias",
          "de": "Ich zeige Zärtlichkeit",
          "it": "Mostro affetto con abbracci, baci o carezze"
        }
      },
      {
        "value": "time",
        "label": {
          "en": "I make time for us",
          "fr": "Je prends du temps pour nous",
          "es": "Busco tiempo para nosotros",
          "de": "Ich nehme mir Zeit für uns",
          "it": "Trovo tempo per noi"
        }
      }
    ],
    "multiSelect": 2
  },
  {
    "id": "v2_enjoyableMoments",
    "contextField": "enjoyableMoments",
    "tier": 2,
    "askAt": "wave_1",
    "text": {
      "en": "What do you most enjoy doing together lately?",
      "fr": "Qu'aimez-vous le plus faire ensemble en ce moment ?",
      "es": "¿Qué disfrutan más hacer juntos últimamente?",
      "de": "Was macht ihr zurzeit besonders gern zusammen?",
      "it": "Cosa vi piace di più fare insieme ultimamente?"
    },
    "options": [
      {
        "value": "talking",
        "label": {
          "en": "Talking about our day",
          "fr": "Parler de notre journée",
          "es": "Hablar de nuestro día",
          "de": "Über unseren Tag reden",
          "it": "Raccontarci la giornata"
        }
      },
      {
        "value": "activity",
        "label": {
          "en": "Sharing an activity",
          "fr": "Faire une activité ensemble",
          "es": "Compartir una actividad",
          "de": "Etwas zusammen unternehmen",
          "it": "Fare un'attività insieme"
        }
      },
      {
        "value": "affection",
        "label": {
          "en": "Being physically close",
          "fr": "Être proches physiquement",
          "es": "Estar cerca físicamente",
          "de": "Körperliche Nähe genießen",
          "it": "Stare vicini fisicamente"
        }
      },
      {
        "value": "everyday",
        "label": {
          "en": "Little everyday moments",
          "fr": "Les petits moments du quotidien",
          "es": "Los pequeños momentos del día a día",
          "de": "Die kleinen Momente im Alltag",
          "it": "I piccoli momenti di ogni giorno"
        }
      },
      {
        "value": "other",
        "label": {
          "en": "Something else",
          "fr": "Autre chose",
          "es": "Otra cosa",
          "de": "Etwas anderes",
          "it": "Qualcos'altro"
        }
      },
      {
        "value": "none",
        "label": {
          "en": "Nothing comes to mind right now",
          "fr": "Rien ne me vient pour le moment",
          "es": "Ahora mismo no se me ocurre nada",
          "de": "Mir fällt gerade nichts ein",
          "it": "Al momento non mi viene in mente nulla"
        }
      }
    ]
  },
  {
    "id": "v2_timeTogetherFrequency",
    "contextField": "timeTogetherFrequency",
    "tier": 2,
    "askAt": "wave_1",
    "text": {
      "en": "How often do you spend time together, just the two of you? Calls count too.",
      "fr": "À quelle fréquence passez-vous du temps à deux ? Les appels comptent aussi.",
      "es": "¿Con qué frecuencia pasan tiempo juntos, solo ustedes dos? Las llamadas también cuentan.",
      "de": "Wie oft verbringt ihr Zeit zu zweit? Telefonate zählen auch.",
      "it": "Quanto spesso passate del tempo solo voi due? Contano anche le chiamate."
    },
    "options": [
      {
        "value": "daily",
        "label": {
          "en": "Every day",
          "fr": "Tous les jours",
          "es": "Todos los días",
          "de": "Jeden Tag",
          "it": "Ogni giorno"
        }
      },
      {
        "value": "few_week",
        "label": {
          "en": "A few times a week",
          "fr": "Quelques fois par semaine",
          "es": "Varias veces a la semana",
          "de": "Mehrmals pro Woche",
          "it": "Qualche volta a settimana"
        }
      },
      {
        "value": "weekly",
        "label": {
          "en": "About once a week",
          "fr": "Environ une fois par semaine",
          "es": "Más o menos una vez a la semana",
          "de": "Etwa einmal pro Woche",
          "it": "Circa una volta a settimana"
        }
      },
      {
        "value": "few_month",
        "label": {
          "en": "A few times a month",
          "fr": "Quelques fois par mois",
          "es": "Varias veces al mes",
          "de": "Mehrmals im Monat",
          "it": "Qualche volta al mese"
        }
      },
      {
        "value": "less",
        "label": {
          "en": "Less often",
          "fr": "Moins souvent",
          "es": "Con menos frecuencia",
          "de": "Seltener",
          "it": "Meno spesso"
        }
      }
    ]
  },
  {
    "id": "v2_talkingComfort",
    "contextField": "talkingComfort",
    "tier": 2,
    "askAt": "wave_2",
    "text": {
      "en": "How comfortable do you feel talking to your partner about something that's upsetting you?",
      "fr": "Vous sentez-vous à l'aise pour parler à votre partenaire de ce qui vous préoccupe ?",
      "es": "¿Qué tan a gusto te sientes al hablar con tu pareja de algo que te preocupa?",
      "de": "Wie wohl fühlst du dich dabei, anzusprechen, was dich belastet?",
      "it": "Quanto ti senti a tuo agio a parlare nella coppia di qualcosa che ti preoccupa?"
    },
    "options": [
      {
        "value": "not_at_all",
        "label": {
          "en": "Not at all comfortable",
          "fr": "Pas du tout à l'aise",
          "es": "Nada a gusto",
          "de": "Überhaupt nicht wohl",
          "it": "Per niente a mio agio"
        }
      },
      {
        "value": "not_very",
        "label": {
          "en": "Not very comfortable",
          "fr": "Pas très à l'aise",
          "es": "Poco a gusto",
          "de": "Eher unwohl",
          "it": "Poco a mio agio"
        }
      },
      {
        "value": "somewhat",
        "label": {
          "en": "Somewhat comfortable",
          "fr": "Assez à l'aise",
          "es": "Algo a gusto",
          "de": "Einigermaßen wohl",
          "it": "Abbastanza a mio agio"
        }
      },
      {
        "value": "very",
        "label": {
          "en": "Very comfortable",
          "fr": "Très à l'aise",
          "es": "Muy a gusto",
          "de": "Sehr wohl",
          "it": "Molto a mio agio"
        }
      },
      {
        "value": "varies",
        "label": {
          "en": "It depends on the topic",
          "fr": "Cela dépend du sujet",
          "es": "Depende del tema",
          "de": "Das hängt vom Thema ab",
          "it": "Dipende dall'argomento"
        }
      }
    ]
  },
  {
    "id": "v2_feelingListenedTo",
    "contextField": "feelingListenedTo",
    "tier": 2,
    "askAt": "wave_2",
    "text": {
      "en": "How often do you feel your partner listens to you?",
      "fr": "À quelle fréquence avez-vous le sentiment que votre partenaire vous écoute ?",
      "es": "¿Con qué frecuencia sientes que tu pareja te escucha?",
      "de": "Wie oft hast du das Gefühl, dass dir in eurer Beziehung zugehört wird?",
      "it": "Quanto spesso senti che nella coppia c'è ascolto per quello che dici?"
    },
    "options": [
      {
        "value": "never",
        "label": {
          "en": "Never",
          "fr": "Jamais",
          "es": "Nunca",
          "de": "Nie",
          "it": "Mai"
        }
      },
      {
        "value": "rarely",
        "label": {
          "en": "Rarely",
          "fr": "Rarement",
          "es": "Rara vez",
          "de": "Selten",
          "it": "Raramente"
        }
      },
      {
        "value": "sometimes",
        "label": {
          "en": "Sometimes",
          "fr": "Parfois",
          "es": "A veces",
          "de": "Manchmal",
          "it": "A volte"
        }
      },
      {
        "value": "often",
        "label": {
          "en": "Often",
          "fr": "Souvent",
          "es": "A menudo",
          "de": "Oft",
          "it": "Spesso"
        }
      },
      {
        "value": "almost_always",
        "label": {
          "en": "Almost always",
          "fr": "Presque toujours",
          "es": "Casi siempre",
          "de": "Fast immer",
          "it": "Quasi sempre"
        }
      }
    ]
  },
  {
    "id": "v2_stressBetweenUs",
    "contextField": "stressBetweenUs",
    "tier": 2,
    "askAt": "wave_2",
    "text": {
      "en": "When life gets stressful, what tends to happen between you?",
      "fr": "Quand le quotidien devient stressant, que se passe-t-il entre vous ?",
      "es": "Cuando la vida se vuelve estresante, ¿qué suele pasar entre ustedes?",
      "de": "Wenn der Alltag stressig wird, was passiert dann zwischen euch?",
      "it": "Quando la vita si fa stressante, cosa succede di solito tra voi?"
    },
    "options": [
      {
        "value": "closer",
        "label": {
          "en": "We pull together",
          "fr": "Nous nous serrons les coudes",
          "es": "Nos apoyamos más",
          "de": "Wir halten zusammen",
          "it": "Facciamo squadra"
        }
      },
      {
        "value": "steady",
        "label": {
          "en": "Things stay much the same",
          "fr": "Cela change peu de choses entre nous",
          "es": "Las cosas siguen más o menos igual",
          "de": "Zwischen uns ändert sich wenig",
          "it": "Tra noi cambia poco"
        }
      },
      {
        "value": "tense",
        "label": {
          "en": "We get more tense with each other",
          "fr": "Nous sommes plus tendus l'un envers l'autre",
          "es": "Hay más tensión entre nosotros",
          "de": "Wir sind angespannter miteinander",
          "it": "C'è più tensione tra noi"
        }
      },
      {
        "value": "distant",
        "label": {
          "en": "We pull away from each other",
          "fr": "Nous prenons de la distance",
          "es": "Nos distanciamos",
          "de": "Wir ziehen uns voneinander zurück",
          "it": "Ci allontaniamo"
        }
      },
      {
        "value": "varies",
        "label": {
          "en": "It depends on what's happening",
          "fr": "Cela dépend de ce qui se passe",
          "es": "Depende de lo que esté pasando",
          "de": "Das hängt von der Situation ab",
          "it": "Dipende da quello che succede"
        }
      }
    ]
  },
  {
    "id": "v2_feelingValued",
    "contextField": "feelingValued",
    "tier": 2,
    "askAt": "wave_2",
    "text": {
      "en": "How often do you feel appreciated by your partner?",
      "fr": "À quelle fréquence sentez-vous que votre partenaire vous apprécie ?",
      "es": "¿Con qué frecuencia sientes que tu pareja te valora?",
      "de": "Wie oft fühlst du dich in eurer Beziehung wertgeschätzt?",
      "it": "Quanto spesso ti senti apprezzato nella tua relazione?"
    },
    "options": [
      {
        "value": "never",
        "label": {
          "en": "Never",
          "fr": "Jamais",
          "es": "Nunca",
          "de": "Nie",
          "it": "Mai"
        }
      },
      {
        "value": "rarely",
        "label": {
          "en": "Rarely",
          "fr": "Rarement",
          "es": "Rara vez",
          "de": "Selten",
          "it": "Raramente"
        }
      },
      {
        "value": "sometimes",
        "label": {
          "en": "Sometimes",
          "fr": "Parfois",
          "es": "A veces",
          "de": "Manchmal",
          "it": "A volte"
        }
      },
      {
        "value": "often",
        "label": {
          "en": "Often",
          "fr": "Souvent",
          "es": "A menudo",
          "de": "Oft",
          "it": "Spesso"
        }
      },
      {
        "value": "almost_always",
        "label": {
          "en": "Almost always",
          "fr": "Presque toujours",
          "es": "Casi siempre",
          "de": "Fast immer",
          "it": "Quasi sempre"
        }
      }
    ]
  },
  {
    "id": "v2_disagreementResponse",
    "contextField": "disagreementResponse",
    "tier": 2,
    "askAt": "wave_3",
    "text": {
      "en": "When you disagree, what do you usually do first?",
      "fr": "Quand vous n'êtes pas d'accord, que faites-vous généralement en premier ?",
      "es": "Cuando no están de acuerdo, ¿qué sueles hacer primero?",
      "de": "Was machst du meistens zuerst, wenn ihr unterschiedlicher Meinung seid?",
      "it": "Quando non siete d'accordo, cosa fai di solito per prima cosa?"
    },
    "options": [
      {
        "value": "talk",
        "label": {
          "en": "I try to talk it through",
          "fr": "J'essaie d'en parler",
          "es": "Intento hablarlo",
          "de": "Ich versuche, darüber zu reden",
          "it": "Provo a parlarne"
        }
      },
      {
        "value": "pause",
        "label": {
          "en": "I ask for a break",
          "fr": "Je demande une pause",
          "es": "Pido una pausa",
          "de": "Ich bitte um eine Pause",
          "it": "Chiedo una pausa"
        }
      },
      {
        "value": "avoid",
        "label": {
          "en": "I try to avoid the subject",
          "fr": "J'essaie d'éviter le sujet",
          "es": "Intento evitar el tema",
          "de": "Ich versuche, das Thema zu vermeiden",
          "it": "Provo a evitare l'argomento"
        }
      },
      {
        "value": "upset",
        "label": {
          "en": "I show how upset I am",
          "fr": "Je montre que cela me touche",
          "es": "Expreso mi malestar",
          "de": "Ich zeige, wie aufgewühlt ich bin",
          "it": "Faccio capire quanto mi turba"
        }
      },
      {
        "value": "quiet",
        "label": {
          "en": "I go quiet",
          "fr": "Je me tais",
          "es": "Me quedo en silencio",
          "de": "Ich werde still",
          "it": "Mi chiudo nel silenzio"
        }
      },
      {
        "value": "varies",
        "label": {
          "en": "It depends",
          "fr": "Cela dépend",
          "es": "Depende",
          "de": "Das kommt darauf an",
          "it": "Dipende"
        }
      }
    ]
  },
  {
    "id": "v2_reconnectingAfterArguments",
    "contextField": "reconnectingAfterArguments",
    "exclusiveOptions": ["unsure"],
    "tier": 2,
    "askAt": "wave_3",
    "text": {
      "en": "After an argument, what helps you reconnect?",
      "fr": "Après une dispute, qu'est-ce qui vous aide à vous retrouver ?",
      "es": "Después de una discusión, ¿qué les ayuda a acercarse de nuevo?",
      "de": "Was hilft euch nach einem Streit, wieder zueinanderzufinden?",
      "it": "Dopo una discussione, cosa vi aiuta a ritrovarvi?"
    },
    "options": [
      {
        "value": "talk",
        "label": {
          "en": "Talking about what happened",
          "fr": "Parler de ce qui s'est passé",
          "es": "Hablar de lo que pasó",
          "de": "Über das Geschehene reden",
          "it": "Parlare di quello che è successo"
        }
      },
      {
        "value": "apology",
        "label": {
          "en": "An apology",
          "fr": "Des excuses",
          "es": "Una disculpa",
          "de": "Eine Entschuldigung",
          "it": "Chiedere scusa"
        }
      },
      {
        "value": "time",
        "label": {
          "en": "Time to cool down",
          "fr": "Du temps pour se calmer",
          "es": "Tiempo para calmarnos",
          "de": "Zeit zum Beruhigen",
          "it": "Un po' di tempo per calmarci"
        }
      },
      {
        "value": "affection",
        "label": {
          "en": "A hug or another affectionate gesture",
          "fr": "Un câlin ou un geste tendre",
          "es": "Un abrazo u otro gesto de cariño",
          "de": "Eine Umarmung oder eine liebevolle Geste",
          "it": "Un abbraccio o un gesto affettuoso"
        }
      },
      {
        "value": "humor",
        "label": {
          "en": "Sharing a laugh",
          "fr": "Rire ensemble",
          "es": "Reírnos juntos",
          "de": "Zusammen lachen",
          "it": "Ridere insieme"
        }
      },
      {
        "value": "unsure",
        "label": {
          "en": "We haven't found what helps yet",
          "fr": "Nous cherchons encore ce qui nous aide",
          "es": "Todavía no sabemos qué nos ayuda",
          "de": "Wir wissen noch nicht, was uns hilft",
          "it": "Non abbiamo ancora capito cosa ci aiuta"
        }
      },
      {
        "value": "rare",
        "label": {
          "en": "We rarely argue",
          "fr": "Nous nous disputons rarement",
          "es": "Casi no discutimos",
          "de": "Wir streiten selten",
          "it": "Discutiamo raramente"
        }
      }
    ],
    "multiSelect": 2
  },
  {
    "id": "v2_supportWhenStruggling",
    "contextField": "supportWhenStruggling",
    "tier": 2,
    "askAt": "wave_3",
    "text": {
      "en": "When you're having a hard time, how does your partner usually respond?",
      "fr": "Quand vous traversez un moment difficile, comment réagit votre partenaire ?",
      "es": "Cuando pasas por un momento difícil, ¿cómo suele responder tu pareja?",
      "de": "Wie reagiert der Mensch an deiner Seite, wenn es dir schlecht geht?",
      "it": "Quando passi un momento difficile, come reagisce di solito il tuo partner?"
    },
    "options": [
      {
        "value": "listens",
        "label": {
          "en": "Listens and supports me",
          "fr": "M'écoute et me soutient",
          "es": "Me escucha y me apoya",
          "de": "Hört mir zu und unterstützt mich",
          "it": "Mi ascolta e mi sostiene"
        }
      },
      {
        "value": "unsure",
        "label": {
          "en": "Wants to help but isn't sure how",
          "fr": "Veut m'aider sans trop savoir comment",
          "es": "Quiere ayudar, pero no sabe bien cómo",
          "de": "Möchte helfen, weiß aber nicht wie",
          "it": "Vorrebbe aiutarmi, ma non sa bene come"
        }
      },
      {
        "value": "ask",
        "label": {
          "en": "Helps when I say what I need",
          "fr": "M'aide quand je précise ce dont j'ai besoin",
          "es": "Me ayuda cuando digo lo que necesito",
          "de": "Hilft, wenn ich sage, was ich brauche",
          "it": "Mi aiuta quando dico di cosa ho bisogno"
        }
      },
      {
        "value": "unavailable",
        "label": {
          "en": "Usually isn't there for me",
          "fr": "N'est généralement pas là pour moi",
          "es": "No suele estar ahí para mí",
          "de": "Ist meistens nicht für mich da",
          "it": "Di solito non c'è per me"
        }
      },
      {
        "value": "worse",
        "label": {
          "en": "Sometimes leaves me feeling worse",
          "fr": "Me fait parfois me sentir moins bien",
          "es": "A veces me hace sentir peor",
          "de": "Gibt mir manchmal ein noch schlechteres Gefühl",
          "it": "A volte mi fa stare peggio"
        }
      },
      {
        "value": "varies",
        "label": {
          "en": "It varies",
          "fr": "Cela varie",
          "es": "Depende",
          "de": "Das ist unterschiedlich",
          "it": "Dipende"
        }
      }
    ]
  },
  {
    "id": "v2_personalTimeBalance",
    "contextField": "personalTimeBalance",
    "tier": 2,
    "askAt": "wave_3",
    "text": {
      "en": "How do you feel about the balance between time together and time to yourself?",
      "fr": "L'équilibre entre vos moments à deux et vos moments à vous vous convient-il ?",
      "es": "¿Cómo te sientes con el equilibrio entre el tiempo juntos y el tiempo para ti?",
      "de": "Wie findest du das Verhältnis zwischen gemeinsamer Zeit und Zeit für dich?",
      "it": "Come ti trovi con l'equilibrio tra il tempo insieme e quello per te?"
    },
    "options": [
      {
        "value": "more_self",
        "label": {
          "en": "I'd like more time to myself",
          "fr": "J'aimerais plus de temps pour moi",
          "es": "Me gustaría tener más tiempo para mí",
          "de": "Ich hätte gern mehr Zeit für mich",
          "it": "Vorrei più tempo per me"
        }
      },
      {
        "value": "right",
        "label": {
          "en": "The balance feels right",
          "fr": "L'équilibre me convient",
          "es": "El equilibrio me parece bien",
          "de": "Das Verhältnis passt für mich",
          "it": "L'equilibrio mi va bene"
        }
      },
      {
        "value": "more_us",
        "label": {
          "en": "I'd like more time together",
          "fr": "J'aimerais plus de temps à deux",
          "es": "Me gustaría tener más tiempo juntos",
          "de": "Ich hätte gern mehr gemeinsame Zeit",
          "it": "Vorrei più tempo insieme"
        }
      },
      {
        "value": "varies",
        "label": {
          "en": "It depends on the week",
          "fr": "Cela dépend des semaines",
          "es": "Depende de la semana",
          "de": "Das ist von Woche zu Woche anders",
          "it": "Dipende dalla settimana"
        }
      }
    ]
  },
  {
    "id": "v2_bigDecisionApproach",
    "contextField": "bigDecisionApproach",
    "tier": 2,
    "askAt": "wave_4",
    "text": {
      "en": "Who usually has the final say on big decisions that affect you both?",
      "fr": "Qui décide généralement en dernier pour les grandes décisions qui vous concernent tous les deux ?",
      "es": "¿Quién suele tener la última palabra en las decisiones importantes que afectan a ambos?",
      "de": "Wer hat bei wichtigen Entscheidungen, die euch beide betreffen, meistens das letzte Wort?",
      "it": "Chi ha di solito l'ultima parola sulle decisioni importanti che riguardano entrambi?"
    },
    "options": [
      {
        "value": "together",
        "label": {
          "en": "We decide together",
          "fr": "Nous décidons ensemble",
          "es": "Decidimos juntos",
          "de": "Wir entscheiden gemeinsam",
          "it": "Decidiamo insieme"
        }
      },
      {
        "value": "me",
        "label": {
          "en": "I usually do",
          "fr": "C'est généralement moi",
          "es": "Yo, normalmente",
          "de": "Meistens ich",
          "it": "Di solito io"
        }
      },
      {
        "value": "partner",
        "label": {
          "en": "My partner usually does",
          "fr": "C'est généralement mon partenaire",
          "es": "Mi pareja, normalmente",
          "de": "Meistens die andere Person",
          "it": "Di solito il mio partner"
        }
      },
      {
        "value": "topic",
        "label": {
          "en": "It depends on the decision",
          "fr": "Cela dépend de la décision",
          "es": "Depende de la decisión",
          "de": "Das hängt von der Entscheidung ab",
          "it": "Dipende dalla decisione"
        }
      },
      {
        "value": "stuck",
        "label": {
          "en": "We often struggle to reach a decision",
          "fr": "Nous avons souvent du mal à trancher",
          "es": "A menudo nos cuesta llegar a una decisión",
          "de": "Wir kommen oft zu keiner Entscheidung",
          "it": "Spesso facciamo fatica a decidere"
        }
      }
    ]
  },
  {
    "id": "v2_valuesAgreement",
    "contextField": "valuesAgreement",
    "tier": 2,
    "askAt": "wave_4",
    "text": {
      "en": "How much do you agree on what matters most in life?",
      "fr": "Êtes-vous d'accord sur ce qui compte le plus dans la vie ?",
      "es": "¿Qué tanto coinciden en lo que más importa en la vida?",
      "de": "Wie einig seid ihr euch darüber, was im Leben am meisten zählt?",
      "it": "Quanto siete d'accordo su ciò che conta di più nella vita?"
    },
    "options": [
      {
        "value": "little",
        "label": {
          "en": "On very little",
          "fr": "Sur très peu de choses",
          "es": "En muy pocas cosas",
          "de": "Bei sehr wenig",
          "it": "Su poche cose"
        }
      },
      {
        "value": "some",
        "label": {
          "en": "On some things",
          "fr": "Sur certaines choses",
          "es": "En algunas cosas",
          "de": "Bei manchen Dingen",
          "it": "Su alcune cose"
        }
      },
      {
        "value": "most",
        "label": {
          "en": "On most things",
          "fr": "Sur la plupart des choses",
          "es": "En la mayoría de las cosas",
          "de": "Bei den meisten Dingen",
          "it": "Sulla maggior parte delle cose"
        }
      },
      {
        "value": "almost_all",
        "label": {
          "en": "On almost everything",
          "fr": "Sur presque tout",
          "es": "En casi todo",
          "de": "Bei fast allem",
          "it": "Su quasi tutto"
        }
      },
      {
        "value": "learning",
        "label": {
          "en": "We're still finding out",
          "fr": "Nous le découvrons encore",
          "es": "Todavía lo estamos descubriendo",
          "de": "Das finden wir gerade erst heraus",
          "it": "Lo stiamo ancora scoprendo"
        }
      }
    ]
  },
  {
    "id": "v2_personalTrust",
    "contextField": "personalTrust",
    "tier": 2,
    "askAt": "wave_4",
    "text": {
      "en": "How much do you feel you can trust your partner?",
      "fr": "À quel point sentez-vous pouvoir faire confiance à votre partenaire ?",
      "es": "¿Qué tanto sientes que puedes confiar en tu pareja?",
      "de": "Wie sehr kannst du der Person an deiner Seite vertrauen?",
      "it": "Quanto senti di poterti fidare del tuo partner?"
    },
    "options": [
      {
        "value": "not_at_all",
        "label": {
          "en": "Not at all",
          "fr": "Pas du tout",
          "es": "Nada",
          "de": "Gar nicht",
          "it": "Per niente"
        }
      },
      {
        "value": "little",
        "label": {
          "en": "A little",
          "fr": "Un peu",
          "es": "Un poco",
          "de": "Ein wenig",
          "it": "Un po'"
        }
      },
      {
        "value": "mostly",
        "label": {
          "en": "For the most part",
          "fr": "En grande partie",
          "es": "En gran medida",
          "de": "Größtenteils",
          "it": "In gran parte"
        }
      },
      {
        "value": "fully",
        "label": {
          "en": "Completely",
          "fr": "Entièrement",
          "es": "Completamente",
          "de": "Voll und ganz",
          "it": "Completamente"
        }
      },
      {
        "value": "unsure",
        "label": {
          "en": "I'm not sure",
          "fr": "Je ne sais pas",
          "es": "No lo sé",
          "de": "Ich bin mir nicht sicher",
          "it": "Non lo so"
        }
      }
    ]
  },
  {
    "id": "v2_physicalAffectionFit",
    "contextField": "physicalAffectionFit",
    "tier": 2,
    "askAt": "wave_4",
    "text": {
      "en": "How do you feel about the hugs, kisses, and other affectionate touch you share?",
      "fr": "Comment vous sentez-vous par rapport aux câlins, aux bisous et aux gestes tendres entre vous ?",
      "es": "¿Cómo te sientes con los abrazos, besos y otras muestras de cariño físico entre ustedes?",
      "de": "Wie geht es dir mit euren Umarmungen, Küssen und anderen zärtlichen Berührungen?",
      "it": "Come ti trovi con gli abbracci, i baci e gli altri gesti di affetto fisico tra voi?"
    },
    "options": [
      {
        "value": "more",
        "label": {
          "en": "I'd like more",
          "fr": "J'en aimerais davantage",
          "es": "Me gustaría que hubiera más",
          "de": "Ich hätte gern mehr davon",
          "it": "Ne vorrei di più"
        }
      },
      {
        "value": "right",
        "label": {
          "en": "It feels right for me",
          "fr": "Cela me convient",
          "es": "Me siento a gusto así",
          "de": "So passt es für mich",
          "it": "Mi va bene così"
        }
      },
      {
        "value": "less",
        "label": {
          "en": "I'd like less",
          "fr": "J'en aimerais moins",
          "es": "Me gustaría que hubiera menos",
          "de": "Ich hätte gern weniger davon",
          "it": "Ne vorrei di meno"
        }
      },
      {
        "value": "different",
        "label": {
          "en": "I'd prefer different kinds of touch",
          "fr": "Je préférerais d'autres gestes",
          "es": "Preferiría otro tipo de contacto",
          "de": "Ich wünsche mir andere Berührungen",
          "it": "Preferirei altri tipi di contatto"
        }
      },
      {
        "value": "not_part",
        "label": {
          "en": "This isn't part of our relationship",
          "fr": "Cela ne fait pas partie de notre relation",
          "es": "No es parte de nuestra relación",
          "de": "Das gehört nicht zu unserer Beziehung",
          "it": "Non fa parte della nostra relazione"
        }
      }
    ]
  },
  {
    "id": "v2_currentDifficulty",
    "contextField": "currentDifficulty",
    "tier": 2,
    "askAt": "wave_5",
    "text": {
      "en": "What's hardest for you as a couple right now?",
      "fr": "Qu'est-ce qui est le plus difficile pour vous deux en ce moment ?",
      "es": "¿Qué es lo más difícil para ustedes como pareja ahora mismo?",
      "de": "Was ist für euch als Paar gerade am schwierigsten?",
      "it": "Cosa vi mette più in difficoltà come coppia in questo momento?"
    },
    "options": [
      {
        "value": "talking",
        "label": {
          "en": "Talking to each other",
          "fr": "Se parler",
          "es": "Hablar entre nosotros",
          "de": "Miteinander reden",
          "it": "Parlarci"
        }
      },
      {
        "value": "time",
        "label": {
          "en": "Finding time together",
          "fr": "Trouver du temps à deux",
          "es": "Encontrar tiempo juntos",
          "de": "Zeit füreinander finden",
          "it": "Trovare tempo insieme"
        }
      },
      {
        "value": "closeness",
        "label": {
          "en": "Feeling close",
          "fr": "Se sentir proches",
          "es": "Sentirnos cerca",
          "de": "Uns nah fühlen",
          "it": "Sentirci vicini"
        }
      },
      {
        "value": "disagreements",
        "label": {
          "en": "Handling disagreements",
          "fr": "Gérer les désaccords",
          "es": "Manejar los desacuerdos",
          "de": "Mit Meinungsverschiedenheiten umgehen",
          "it": "Affrontare i disaccordi"
        }
      },
      {
        "value": "trust",
        "label": {
          "en": "Trust",
          "fr": "La confiance",
          "es": "La confianza",
          "de": "Vertrauen",
          "it": "La fiducia"
        }
      },
      {
        "value": "stress",
        "label": {
          "en": "Stress from everyday life",
          "fr": "Le stress du quotidien",
          "es": "El estrés del día a día",
          "de": "Alltagsstress",
          "it": "Lo stress quotidiano"
        }
      },
      {
        "value": "other",
        "label": {
          "en": "Something else",
          "fr": "Autre chose",
          "es": "Otra cosa",
          "de": "Etwas anderes",
          "it": "Qualcos'altro"
        }
      },
      {
        "value": "none",
        "label": {
          "en": "Nothing in particular",
          "fr": "Rien en particulier",
          "es": "Nada en particular",
          "de": "Nichts Bestimmtes",
          "it": "Niente in particolare"
        }
      }
    ]
  },
  {
    "id": "v2_wantedFromPartner",
    "contextField": "wantedFromPartner",
    "tier": 2,
    "askAt": "wave_5",
    "text": {
      "en": "What would you like more of from your partner?",
      "fr": "Qu'aimeriez-vous recevoir davantage de votre partenaire ?",
      "es": "¿Qué te gustaría recibir más de tu pareja?",
      "de": "Was wünschst du dir mehr von der Person an deiner Seite?",
      "it": "Cosa vorresti ricevere di più dal tuo partner?"
    },
    "options": [
      {
        "value": "affection",
        "label": {
          "en": "Affection",
          "fr": "De l'affection",
          "es": "Cariño",
          "de": "Zuneigung",
          "it": "Affetto"
        }
      },
      {
        "value": "listening",
        "label": {
          "en": "Listening",
          "fr": "De l'écoute",
          "es": "Escucha",
          "de": "Zuhören",
          "it": "Ascolto"
        }
      },
      {
        "value": "appreciation",
        "label": {
          "en": "Appreciation",
          "fr": "De la reconnaissance",
          "es": "Aprecio",
          "de": "Wertschätzung",
          "it": "Riconoscimento"
        }
      },
      {
        "value": "initiative",
        "label": {
          "en": "Taking the initiative",
          "fr": "Des initiatives",
          "es": "Iniciativa",
          "de": "Eigeninitiative",
          "it": "Iniziativa"
        }
      },
      {
        "value": "time",
        "label": {
          "en": "Time and attention",
          "fr": "Du temps et de l'attention",
          "es": "Tiempo y atención",
          "de": "Zeit und Aufmerksamkeit",
          "it": "Tempo e attenzione"
        }
      },
      {
        "value": "kindness",
        "label": {
          "en": "Kindness when we disagree",
          "fr": "De la douceur dans les désaccords",
          "es": "Amabilidad cuando no estamos de acuerdo",
          "de": "Freundlichkeit bei Meinungsverschiedenheiten",
          "it": "Gentilezza quando non siamo d'accordo"
        }
      },
      {
        "value": "none",
        "label": {
          "en": "Nothing in particular",
          "fr": "Rien en particulier",
          "es": "Nada en particular",
          "de": "Nichts Bestimmtes",
          "it": "Niente in particolare"
        }
      }
    ]
  },
  {
    "id": "v2_wantedContribution",
    "contextField": "wantedContribution",
    "tier": 2,
    "askAt": "wave_5",
    "text": {
      "en": "What's one thing you'd like to do more often for your partner?",
      "fr": "Que voudriez-vous faire plus souvent pour votre partenaire ?",
      "es": "¿Qué te gustaría hacer más a menudo por tu pareja?",
      "de": "Was möchtest du öfter für den Menschen an deiner Seite tun?",
      "it": "Cosa vorresti fare più spesso per il tuo partner?"
    },
    "options": [
      {
        "value": "affection",
        "label": {
          "en": "Show affection",
          "fr": "Montrer mon affection",
          "es": "Mostrar cariño",
          "de": "Zuneigung zeigen",
          "it": "Mostrare affetto"
        }
      },
      {
        "value": "listen",
        "label": {
          "en": "Listen without interrupting",
          "fr": "Écouter sans interrompre",
          "es": "Escuchar sin interrumpir",
          "de": "Zuhören, ohne zu unterbrechen",
          "it": "Ascoltare senza interrompere"
        }
      },
      {
        "value": "thanks",
        "label": {
          "en": "Say thank you",
          "fr": "Dire merci",
          "es": "Dar las gracias",
          "de": "Danke sagen",
          "it": "Dire grazie"
        }
      },
      {
        "value": "initiative",
        "label": {
          "en": "Take the initiative",
          "fr": "Prendre des initiatives",
          "es": "Tomar la iniciativa",
          "de": "Die Initiative ergreifen",
          "it": "Prendere l'iniziativa"
        }
      },
      {
        "value": "time",
        "label": {
          "en": "Make time for us",
          "fr": "Prendre du temps pour nous",
          "es": "Encontrar tiempo para nosotros",
          "de": "Mir Zeit für uns nehmen",
          "it": "Trovare tempo per noi"
        }
      },
      {
        "value": "kindness",
        "label": {
          "en": "Speak kindly when we disagree",
          "fr": "Parler avec douceur quand nous ne sommes pas d'accord",
          "es": "Hablar con amabilidad cuando no estamos de acuerdo",
          "de": "Bei Meinungsverschiedenheiten freundlich bleiben",
          "it": "Parlare con gentilezza quando non siamo d'accordo"
        }
      },
      {
        "value": "unsure",
        "label": {
          "en": "I'm not sure yet",
          "fr": "Je ne sais pas encore",
          "es": "Todavía no lo sé",
          "de": "Das weiß ich noch nicht",
          "it": "Non lo so ancora"
        }
      }
    ]
  },
  {
    "id": "v2_futureFeelings",
    "contextField": "futureFeelings",
    "tier": 2,
    "askAt": "wave_5",
    "text": {
      "en": "How do you feel when you think about your future together?",
      "fr": "Que ressentez-vous quand vous pensez à votre avenir à deux ?",
      "es": "¿Cómo te sientes cuando piensas en su futuro juntos?",
      "de": "Was fühlst du, wenn du an eure gemeinsame Zukunft denkst?",
      "it": "Cosa provi quando pensi al vostro futuro insieme?"
    },
    "options": [
      {
        "value": "hopeful",
        "label": {
          "en": "Hopeful",
          "fr": "De l'espoir",
          "es": "Esperanza",
          "de": "Hoffnung",
          "it": "Speranza"
        }
      },
      {
        "value": "calm",
        "label": {
          "en": "At ease",
          "fr": "De la sérénité",
          "es": "Tranquilidad",
          "de": "Zuversicht und Ruhe",
          "it": "Serenità"
        }
      },
      {
        "value": "uncertain",
        "label": {
          "en": "Uncertain",
          "fr": "De l'incertitude",
          "es": "Incertidumbre",
          "de": "Unsicherheit",
          "it": "Incertezza"
        }
      },
      {
        "value": "worried",
        "label": {
          "en": "Worried",
          "fr": "De l'inquiétude",
          "es": "Preocupación",
          "de": "Sorge",
          "it": "Preoccupazione"
        }
      },
      {
        "value": "mixed",
        "label": {
          "en": "A mix of feelings",
          "fr": "Un mélange de sentiments",
          "es": "Una mezcla de emociones",
          "de": "Gemischte Gefühle",
          "it": "Un insieme di emozioni"
        }
      },
      {
        "value": "not_now",
        "label": {
          "en": "I'd rather not think about it right now",
          "fr": "Je préfère ne pas y penser pour le moment",
          "es": "Prefiero no pensarlo ahora",
          "de": "Ich möchte gerade nicht darüber nachdenken",
          "it": "Preferisco non pensarci per ora"
        }
      }
    ]
  }
];
